/**
 * 資產類別／業務類別 選項定義（ticket 06）— 機櫃／硬體／軟體三個模組共用同一份來源。
 *
 * 資產類別：五個固定選項（機房相關／網路相關／系統相關／軟體相關／其他）。
 * 業務類別：一類／二類／三類的單選（依主計劃 spec「Implementation Decisions」定案）。
 *   既有 mock 種子曾把第三類寫成「共用設施」，與定案不符，已改回「三類業務」。
 * 客戶端實際的分類對應與命名仍待回覆（ticket 27），這裡只落實程式端的統一定義。
 *
 * 原本另有一個選填的自定義分類文字欄位（customCategory）——
 * UAT 8/27 客戶回饋是多的欄位，已從機櫃/硬體/軟體三張表單移除。
 */
export const ASSET_TYPES = ["機房相關", "網路相關", "系統相關", "軟體相關", "其他"];
export const BIZ_TYPES = ["一類業務", "二類業務", "三類業務"];
